<div class="bulk-layout" [class.bulk-layout--no-padding]="mobile">
  <button mat-stroked-button color="primary" class="btn-above-content" (click)="closeRequested.emit()">
    {{ 'case.tasks.individual-rating' | translate | capitalize }}
  </button>

  <div class="table-wrapper"
    [class.table-wrapper-height-selection]="selection.selected.length > 0"
    [class.table-wrapper--mobile-bar-visible]="mobile && selection.selected.length > 0">
    <table mat-table [dataSource]="dataSource" class="bulk-table">

      <!-- Checkbox column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            color="primary">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
            color="primary">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Name column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'general.words.name' | translate | capitalize }}
        </th>
        <td mat-cell *matCellDef="let row">
          @if (!row.taskWorkgroup.workgroup.isStudent) {
            <span>{{ row.taskWorkgroup.workgroup.name }}</span>
          }
          @if (row.taskWorkgroup.workgroup.isStudent) {
            <span>
              {{ row.taskWorkgroup.workgroup.students[0].firstname }}
              {{ row.taskWorkgroup.workgroup.students[0].lastname }}
            </span>
          }
        </td>
      </ng-container>

      <!-- Type column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'general.words.type' | translate | capitalize }}
        </th>
        <td mat-cell *matCellDef="let row">
          @if (row.taskWorkgroup.workgroup.isStudent) {
            <span>{{ 'case.tasks.individual-student' | translate | capitalize }}</span>
          }
          @if (!row.taskWorkgroup.workgroup.isStudent) {
            <span>{{ 'general.words.workgroup' | translate | capitalize }}</span>
          }
        </td>
      </ng-container>

      <!-- Rating column -->
      <ng-container matColumnDef="rating">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'general.words.rating' | translate | capitalize }}
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-form-field appearance="outline" class="row-dropdown" [subscriptSizing]="'dynamic'">
            <mat-select
              (selectionChange)="onRatingSingleChange(row, $event)"
              [value]="row.lastRatingId">
              @for (rating of sortedRatings; track rating.id) {
                <mat-option [value]="rating.id">{{ rating.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- State column -->
      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'general.words.state' | translate | capitalize }}
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-form-field appearance="outline" class="row-dropdown" [subscriptSizing]="'dynamic'">
            <mat-select
              (selectionChange)="onStateSingleChange(row, $event)"
              [value]="row.stateName">
              @for (state of sortedStates; track state.name) {
                <mat-option class="state-select-option" [value]="state.name">
                  <app-state-box [state]="state.name" [student]="false" position="left"></app-state-box>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.row--selected]="selection.isSelected(row)"></tr>
    </table>
  </div>

  <!-- Bulk multi-selection action bar -->
  @if (selection.selected.length > 0) {
    <div [@inOutAnimation] class="bulk-action-bar" [class.bulk-action-bar--mobile]="mobile">
      <div class="bulk-selection-count">
        @if (bulkSelectionChangeDisabled) {
          <mat-spinner diameter="20" class="bulk-spinner"></mat-spinner>
        }
        @if (!bulkSelectionChangeDisabled) {
          <span class="selected-count">{{ selection.selected.length }}</span>
        }
        <span>{{ 'general.words.selected' | translate | capitalize }}</span>
      </div>

      @if (task.toRate) {
        <mat-form-field
          appearance="outline"
          class="action-bar-dropdown"
          [subscriptSizing]="'dynamic'"
          [class.action-bar-dropdown--full]="mobile">
          <mat-label>{{ 'general.words.rating' | translate | capitalize }}: {{ caseRatingSystem.name }}</mat-label>
          <mat-select
            (selectionChange)="onBulkSelectionRatingChange($event)"
            [disabled]="bulkSelectionChangeDisabled">
            @for (rating of sortedRatings; track rating.id) {
              <mat-option [value]="rating.id">{{ rating.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-form-field
        appearance="outline"
        class="action-bar-dropdown"
        [subscriptSizing]="'dynamic'"
        [class.action-bar-dropdown--full]="mobile">
        <mat-label>{{ 'general.words.state' | translate | capitalize }}</mat-label>
        <mat-select (selectionChange)="onBulkStateSelectionChange($event)">
          @for (state of sortedStates; track state.name) {
            <mat-option class="state-select-option" [value]="state.name">
              <app-state-box [state]="state.name" [student]="false" position="left"></app-state-box>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
</div>
